export default "__VITE_ASSET__DuOhbYfv__"